//  scp -r ./* learnfp1@learnforeverlearn.com:/home1/learnfp1/public_html/pbskills/
// App.tsx
import React, { useMemo, useState } from "react";
import { Box, Button, useMediaQuery, useTheme } from "@mui/material";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@mui/material";
import InfoDialog from "./InfoDialog";

import TopBar from "./TopBar";
import LevelTableDialog from "../viz/LevelTableDialog";
import type { SkillLevel, SkillNode } from "../types";

import { useDeviceLayout } from "../utils/useDeviceLayout";

// ⬇ bring in the skills tree and the id-index helper
import { skillsRoot, buildIdIndex } from "../components/GalaxyScene";
import Skills2D from "../viz/Skills2D";

const LEVELS: SkillLevel[] = [
  "3.5",
  "4.0",
  "4.5",
  "5.0",
  "5.5",
  "6.0",
  "6.0 Invisible Skills",
];

export function getCategoryTitleById(
  id: string,
  idIndex: Record<string, SkillNode>,
) {
  return idIndex[id]?.name ?? id;
}

function useLayoutFlags() {
  const theme = useTheme();

  // Your old "small" flag (width-based)
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  // NEW: orientation flags
  const isLandscape = useMediaQuery("(orientation: landscape)");
  const isPortrait = useMediaQuery("(orientation: portrait)");

  // Handy combo: phone-ish & landscape
  const isPhoneLandscape = useMediaQuery(
    `(max-width:${theme.breakpoints.values.sm}px) and (orientation: landscape)`,
  );

  return { isSmall, isLandscape, isPortrait, isPhoneLandscape };
}
function useDeviceFlags() {
  const theme = useTheme();

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isNonDesktop = !isDesktop; // phone + small tablets

  return { isDesktop, isNonDesktop };
}

function App() {
  const theme = useTheme();
  //const isSmall = useMediaQuery(theme.breakpoints.down('md')); // phone / small tablet

  //   const { isSmall, isLandscape, isPhoneLandscape } = useLayoutFlags();
  // const { isDesktop, isNonDesktop } = useDeviceFlags();

  // Level table (by level) state
  const [levelDialogOpen, setLevelDialogOpen] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState<SkillLevel | null>(null);

  // Category table (by category) state
  const [catDialogOpen, setCatDialogOpen] = useState(false);
  const [catId, setCatId] = useState<string | null>(null);

  // Build a quick id → node map once
  const idIndex = useMemo(() => buildIdIndex(skillsRoot), []);

  const [open, setOpen] = useState(false);

  const [whatsThisOpen, setWhatsThisOpen] = React.useState(false);

  const openLevel = (lvl: SkillLevel) => {
    setSelectedLevel(lvl);
    setLevelDialogOpen(true);
  };

  const openCategory = (id: string) => {
    setCatId(id);
    setCatDialogOpen(true);
  };

  const { isPhone, isTablet, isDesktop, isLandscape } = useDeviceLayout();

  // For Skills2D:
  const isSmall = isPhone; // your compact mode
  const mobileish = isPhone || isTablet; // anything touch-based

  // 🔍 Responsive tuning
  const radiusPx = isSmall ? 170 : 320; // smaller core on phones
  // const riderDensity = isSmall ? 0.5 : 0.9; // fewer riders on phones
  // const riderPerLabelMax = isSmall ? 1 : 3; // less clutter on phones

  const riderDensity = 0.9;
const riderPerLabelMax = 1; //1; //2;


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        bgcolor: "#050815",
      }}
    >
      {/* Header */}
      {/* <TopBar isSmall={isSmall || !isDesktop} /> */}


{/* Level buttons */}
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    px: 2,
    //py: 1,
    paddingTop:"6px",
    paddingBottom:0,
    bgcolor: "#0b1020",
    borderBottom: "1px solid #101a3a",
    zIndex: 2,
    gap: 1,
  }}
>
  <Box sx={{ flex: 1 }} />

  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: 1,
      flex: "0 1 auto",
    }}
  >
    {LEVELS.map((lvl) => (
      <Button
        key={lvl}
        variant={
          selectedLevel === lvl && levelDialogOpen
            ? "contained"
            : "outlined"
        }
        onClick={() => openLevel(lvl)}
        sx={{
          color: "#cfe0ff",
          borderColor: "#1f2b57",
          px: isSmall || !isDesktop ? 1.5 : 2.5,
          minWidth: isSmall || !isDesktop ? 90 : 120,
          fontSize: isSmall || !isDesktop ? "0.7rem" : "0.85rem",
          whiteSpace: "nowrap",
        }}
      >
        Level {lvl}
      </Button>
    ))}
  </Box>

  <Box
    sx={{
      flex: 1,
      display: "flex",
      justifyContent: "flex-end",
      minWidth: 0,
    }}
  >
    <Box
      onClick={() => setWhatsThisOpen(true)}
      sx={{
        color: "#FFFFFF",
        textDecoration: "underline",
        fontSize: 14,
        fontWeight: 700,
        cursor: "pointer",
        display: "inline-block",
        userSelect: "none",
        whiteSpace: "nowrap",
      }}
    >
      What is this?
    </Box>
  </Box>
</Box>

      {/* Level buttons */}
      {/* <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: 1,
          px: 2,
          py: 1,
          bgcolor: "#0b1020",
          borderBottom: "1px solid #101a3a",
          zIndex: 2,
        }}
      >
        {LEVELS.map((lvl) => (
          <Button
            key={lvl}
            variant={
              selectedLevel === lvl && levelDialogOpen
                ? "contained"
                : "outlined"
            }
            onClick={() => openLevel(lvl)}
            sx={{
              color: "#cfe0ff",
              borderColor: "#1f2b57",

              px: isSmall || !isDesktop ? 1.5 : 2.5,
              minWidth: isSmall || !isDesktop ? 90 : 120,
              fontSize: isSmall || !isDesktop ? "0.7rem" : "0.85rem",
            }}
          >
            Level {lvl}
          </Button>
        ))}
        <Box
          onClick={() => setWhatsThisOpen(true)}
          sx={{
            color: "#FFFFFF",
            textDecoration: "underline",
            fontSize: 14,
            fontWeight: 700,
            cursor: "pointer",
            display: "inline-block",
            userSelect: "none",
          }}
        >
          What is this?
        </Box>
      </Box> */}

      {/* Main stage */}
      <Box
        sx={{
          position: "relative",
          //flex:1,
          height: "calc(100vh - 64px)",
          minHeight: 0,
          width: "100%",
          transform: "translateY(-8px)",

        }}
      >
        <Skills2D
          isSmall={isSmall}
          isLandscape={isLandscape}
          isDesktop={isDesktop}
          radiusPx={radiusPx}
          onOpenCategory={openCategory}
          riderDensity={riderDensity}
          riderBaseSpeedPxPerSec={190}
          riderSpeedMultiplier={0.2}
          riderReleaseBaseMs={100}
          // riderReleaseJitterMs={900}
          riderPerLabelMax={riderPerLabelMax}
        />

        {/* Overlay root if you need it later */}
        <div
          id="overlay-root"
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            pointerEvents: "none",
          }}
        />
      </Box>

      {/* Level-based table */}
      <LevelTableDialog
        isSmall={isSmall}
        isLandscape={isLandscape}
        skillsRoot={skillsRoot}
        open={levelDialogOpen}
        level={selectedLevel}
        onClose={() => setLevelDialogOpen(false)}
        idIndex={idIndex}
      />

      {/* Category-based table */}
      <LevelTableDialog
        isSmall={isSmall}
        isLandscape={isLandscape}
        skillsRoot={skillsRoot}
        open={catDialogOpen}
        onClose={() => setCatDialogOpen(false)}
        mode="category"
        level={null}
        categoryId={catId ?? null}
        titleOverride={
          catId
            ? `Skills for ${getCategoryTitleById(catId, idIndex)}`
            : undefined
        }
        idIndex={idIndex}
      />

      <InfoDialog open={open} onClose={() => setOpen(false)} />

      <Dialog
        open={whatsThisOpen}
        onClose={() => setWhatsThisOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{ zIndex: "300000 !important" }}
      >
        <DialogTitle>What is this?</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            This is a map of pickleball skills. It is overwhelming how
            many different things there are to learn, practice, and remember.
            That's part of the beauty of it.
          </Typography>
          {/* <Typography gutterBottom>
            Some people are naturally gifted and can play well without ever
            really breaking things down. I&apos;m not one of those people. I
            like to see the whole landscape: serves, returns, thirds, hands,
            patterns, footwork, mental game, and the “invisible” stuff that
            separates levels.
          </Typography> */}
          {/* <Typography gutterBottom>
            This view is my attempt to start the process of laying all of that
            out in one place just to try to see it.
          </Typography> */}

          <Typography gutterBottom sx={{ opacity: isSmall ? 0 : 1 }}>
            <Box sx={{ fontStyle: "italic", marginTop: "15px" }}>
              {'"The lyf so short, the craft so long to lerne."'}
            </Box>
            <Box sx={{ textAlign: "center" }}>
              {"Chaucer, "}
              <span style={{ fontStyle: "italic" }}> Parlement of Foules</span>
              {", 1382"}
            </Box>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWhatsThisOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default App;
